/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { browserHistory } from 'react-router';
import { AppContainer } from 'react-hot-loader';
import Root from './components/Root';
import store from './store/store';
require('./favicon.ico'); // Tell webpack to load favicon.ico
import 'semantic-ui-css/semantic.min.css';
import 'animate.css';
import './styles/style.scss';
import { syncHistoryWithStore } from 'react-router-redux';

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

window.onload = function() {
  document.body.id = "app-is-loaded";
};

render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('app')
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js